
/**
 * IntlTelInput on webform
 */
function initWebformIntlTelInput_bak(){
  
  var inputs = document.querySelectorAll('.intl-tel-input');

  if(inputs.length == 0) return;

  inputs.forEach(i => {
    var iti = intlTelInput(i, {
      utilsScript: "/themes/custom/nktaxi/dist/js/intlTelInput-utils.js",
      initialCountry: document.documentElement.lang == 'fr' ? 'fr' : 'gb',
      customPlaceholder: (selectedCountryPlaceholder, selectedCountryData) => {
        return document.documentElement.lang == 'fr' ? 'Téléphone (ex : ' + selectedCountryPlaceholder + ')' : 'Phone number (e.g. ' + selectedCountryPlaceholder + ')';
      }
    });
  });
  

} 

function initWebformIntlTelInput(){
  const inputs = document.querySelectorAll(".intl-tel-input");

  if(inputs.length == 0) return;
  
  inputs.forEach(originalInput => {

    if(originalInput.id.includes('clone')) return;

    if(document.getElementById(originalInput.id + '-clone')) return;

    let clonedElement = originalInput.parentNode.cloneNode(true);
    let clonedInput = clonedElement.querySelector(".intl-tel-input");
    let clonedErrorMessage = clonedElement.querySelector(".form-item--error-message");
    if(!clonedErrorMessage){
      clonedErrorMessage = document.createElement('div');
      clonedErrorMessage.classList.add('form-item--error-message');
      clonedInput.after(clonedErrorMessage);
    }
    clonedInput.id = originalInput.id + '-clone';
    clonedInput.setAttribute('data-drupal-selector', clonedInput.id);
    clonedInput.name = clonedInput.id;
    originalInput.parentNode.after(clonedElement);

    originalInput.parentNode.style.opacity = 0;
    originalInput.parentNode.style.position = 'absolute';
    

    const iti = window.intlTelInput(clonedInput, {
      utilsScript: "/themes/custom/nktaxi/dist/js/intlTelInput-utils.js",
      initialCountry: document.documentElement.lang == 'fr' ? 'fr' : 'gb',
      customPlaceholder: (selectedCountryPlaceholder, selectedCountryData) => {
        return document.documentElement.lang == 'fr' ? 'Téléphone (ex : ' + selectedCountryPlaceholder + ')' : 'Phone number (e.g. ' + selectedCountryPlaceholder + ')';
      }
    });

    iti.promise.then(() => {
        
      clonedInput.addEventListener('countrychange', () => {
        //if(iti.isPossibleNumber()){
        if(iti.isValidNumber()){
          originalInput.value = iti.getNumber(intlTelInputUtils.numberFormat.E164);
        }else{
          originalInput.value = '';
        }
      });

      clonedInput.addEventListener('input', () => {
        //if(iti.isPossibleNumber()){
        if(iti.isValidNumber()){
          originalInput.value = iti.getNumber(intlTelInputUtils.numberFormat.E164);
        }else{
          originalInput.value = '';
        }

        let error = iti.getValidationError();
        switch(error){
          case 1: // INVALID_COUNTRY_CODE
            clonedErrorMessage.innerHTML = 'Le numéro semble invalide';
            clonedElement.classList.add('form-item--error');
            clonedInput.classList.add('error');
            break;
          case 2: // TOO_SHORT
            clonedErrorMessage.innerHTML = 'Le numéro semble invalide';
            clonedElement.classList.add('form-item--error');
            clonedInput.classList.add('error');
            break;
          case 3: // TOO_LONG
            clonedErrorMessage.innerHTML = 'Le numéro semble invalide (trop long)';
            clonedElement.classList.add('form-item--error');
            clonedInput.classList.add('error');
            break;
          case 4: // IS_POSSIBLE_LOCAL_ONLY
            clonedErrorMessage.innerHTML = 'Le numéro semble invalide';
            clonedElement.classList.add('form-item--error');
            clonedInput.classList.add('error');
            break;
          case 5: // INVALID_LENGTH
            clonedErrorMessage.innerHTML = 'Le numéro semble invalide'; 
            clonedElement.classList.add('form-item--error');
            clonedInput.classList.add('error');
            break;
          default:
            clonedErrorMessage.innerHTML = '';
            clonedElement.classList.remove('form-item--error');
            clonedInput.classList.remove('error');
            break;
        }
      });

    });

    

  });
}
document.addEventListener('DOMContentLoaded', function() {
  initWebformIntlTelInput();
});
